module.exports = __webpack_public_path__ + "static/img/050204.93a365a9.png";